/* eslint-disable no-unsafe-optional-chaining */
import { Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import palette from '../theme/palette';
import ClockIcon from '../svg/ClockIcon';
import SunIcon from '../svg/sun.svg';
import SunriseIcon from '../svg/sunrise.svg';
import MoonIcon from '../svg/moon.svg';

function TimeBaseImage(time) {
  const hour = moment(time).hour();

  if (hour >= 0 && hour <= 6) {
    return <img src={MoonIcon} alt="moon" />;
  }
  if (hour >= 7 && hour < 12) {
    return <img src={SunriseIcon} alt="sunrise" />;
  }
  if (hour < 18) {
    return <img src={SunIcon} alt="sun" />;
  }
  return <img src={MoonIcon} alt="moon" />;
}

export function DisplayTimeOfClass({ schedule }) {
  // Add leading 0 to hour when hour is less than 10
  const returnLeadingZero = (time) => {
    if (moment(time).format('h') < 10) {
      return 0;
    }

    return '';
  };

  return schedule?.map((sc) => {
    if (sc.selected) {
      return (
        <Stack direction="row" spacing={1} alignItems="baseline" mb={2} key={sc?.selected + sc.day}>
          <ClockIcon color={palette.secondary.main} />
          <Typography>{sc.day} - </Typography>

          <Stack spacing={0.5}>
            {sc.slots.map((sl) => (
              <Stack direction="row" spacing={1} alignItems="center" key={sl._id}>
                <Typography>
                  {`${returnLeadingZero(sl.from)}${moment(sl.from).format('LT')}`} -{' '}
                  {`${returnLeadingZero(sl.to)}${moment(sl.to).format('LT', {
                    trim: false
                  })}`}
                </Typography>
                {TimeBaseImage(sl.from)}
              </Stack>
            ))}
          </Stack>
        </Stack>
      );
    }
    return null;
  });
}

DisplayTimeOfClass.propTypes = {
  schedule: PropTypes.array
};

export default function ClassTimeTable({ isOpen, handleClose, schedule }) {
  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth>
      <DialogTitle>Time table</DialogTitle>
      <DialogContent>
        <DisplayTimeOfClass schedule={schedule} />
      </DialogContent>
    </Dialog>
  );
}

ClassTimeTable.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  schedule: PropTypes.array
};
